import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'

import { compose, pure } from 'recompose'

import { Modal } from 'containers/misc'
import { QuestionForm } from 'containers/forms/profile-questions'
import { Question } from 'components/sections/profile-questions'
import { Title, Section } from 'components/layout'
import { ProfileQuestionsLoader } from 'components/loaders'
import { Button } from 'components/misc'
import { apiConfiguration, apiProfileQuestions } from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'
import { modal } from 'redux/modules/app'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { get, toNumber } from 'lodash'
import ConfigKey from '../../forms/configuration/ConfigKey/ConfigKey'
import { ConfigurationKeySetModal } from '../../../components/modals'

const enhance = compose(
    pure,
    meta({
        title: 'Profile questions',
        intlKey: 'meta.profile_questions'
    }),
    apiProfileQuestions({
        list: true
    }),
    apiConfiguration(),
    connect(state => ({
        configuration: state.api.configuration
    }), { modal })
)

class ProfileQuestions extends Component {
    static propTypes = {
        modal: PropTypes.func.isRequired,
        profileQuestions: PropTypes.object.isRequired,
        addNewQuestion: PropTypes.func.isRequired,
        editQuestion: PropTypes.func.isRequired,
        removeQuestion: PropTypes.func.isRequired,
        configuration: PropTypes.object,
        activeOrganization: PropTypes.number,
        options: PropTypes.object,
        onUpdateConfigKey: PropTypes.func,
        onResetConfigKey: PropTypes.func,
        reset: PropTypes.func,
        change: PropTypes.func,
        initialize: PropTypes.func,
        editCustomizationEnabled: PropTypes.bool,
        isConfigUpdating: PropTypes.bool,
        handleSubmit: PropTypes.func,
        onGetConfigurationValue: PropTypes.func
    }

    state = {
        questionIdToRemove: null,
        data: {}
    }


    componentDidMount = () => {
        const orgId = toNumber(this.props.params.id || this.props.activeOrganization.id)

        orgId && this.props.onGetConfigurationValue(CONFIGURATION_KEYS.profileQuestionDescription.id, orgId)
    }

    handleEditQuestion = id => {
        const { profileQuestions } = this.props
        const questionToEdit = profileQuestions.list
            .filter(item => item.id === id)
            .map(item => ({
                id: item.id,
                questionText: item.translatedText,
                questionType: item.questionType,
                isOptional: item.isOptional,
                parentalConsentHide: item.parentalConsentHide,
                parentalConsentOnly: item.parentalConsentOnly,
                questionOptions: item.profileQuestionOptions.map(option => ({
                    value: option.translatedText,
                    id: option.id
                }))
            }))[0]

        this.setState(
            {
                data: questionToEdit
            },
            () => {
                this.props.modal('modal-add-new-question')
            }
        )
    }

    handleRemoveQuestion = id => {
        this.setState(
            {
                questionIdToRemove: id
            },
            () => {
                this.props.modal('modal-remove-question')
            }
        )
    }

    handleChangeConfig = config => {
        this.setState(
            {
                config
            },
            () => {
                this.props.modal(`modal-configuration-key-${this.key}`)
            }
        )
    }

    handleClose = () => {
        this.props.modal(null)
        this.setState({
            data: {}
        })
    }

    handleNew = () => {
        this.props.modal('modal-add-new-question')
        this.props.initialize({})
    }

    render() {
        const { profileQuestions, configuration, activeOrganization, params, options, handleSubmit,editCustomizationEnabled } = this.props

        const orgId = toNumber(params.id || activeOrganization.id)

        return (
            <Section
                loading={profileQuestions.loading}
                contentLoader={<ProfileQuestionsLoader />}
            >
                {!profileQuestions.loading &&
                profileQuestions.list.length === 0 &&
                <span>No questions set up</span>}

                <div className="row">
                    <div className="col-xs-12">
                        <div className="base-margin--bottom text--right">
                            <QuestionForm
                                addNewQuestion={this.props.addNewQuestion}
                                editQuestion={(fields, questions) => {
                                    this.props.editQuestion(fields, questions)
                                    this.handleClose()
                                }}
                                questions={profileQuestions.list}
                                modal={this.props.modal}
                                data={this.state.data}
                                requestClose={this.handleClose}
                            />
                        </div>
                        <div className="col-xs-12">
                            <div style={{ marginTop: '20px' }}>
                                <ConfigKey
                                    config={get(
                                        configuration,
                                        `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.profileQuestionDescription.id}]`
                                    )}
                                    onConfigEdit={this.handleChangeConfig}
                                    activeOrganization={activeOrganization}
                                    editCustomizationEnabled={editCustomizationEnabled}
                                    standalone
                                    isSameLevel
                                    compact
                                    options={options}
                                />
                            </div>
                        </div>
                        <div style={{ float: 'right', marginBottom: '20px' }}>
                            <div className="col-xs-12">
                                {editCustomizationEnabled &&  <Button
                                    onClick={this.handleNew}
                                    intlKey="button.add_new_profile_question"
                                >
                                    Add new profile question
                                </Button>}
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        {profileQuestions.list.map((item, index) => (
                            <Question
                                key={index}
                                question={item}
                                editQuestion={this.handleEditQuestion}
                                removeQuestion={this.handleRemoveQuestion}
                                editCustomizationEnabled={editCustomizationEnabled}
                                modal={this.props.modal}
                            />
                        ))}
                    </div>
                </div>
                <Modal id="modal-remove-question" customActions>
                    <Title h2 className="text--center" intlKey="moduleTitle.are_you_sure">
                        Are you sure?
                    </Title>
                    <div className="row">
                        <div className="col-xs-6">
                            <Button
                                intlKey="button.close"
                                secondary
                                onClick={() => this.props.modal(null)}
                            >
                                Close
                            </Button>
                        </div>
                        <div className="col-xs-6 text--right">
                            <Button
                                intlKey="button.remove"
                                negative
                                onClick={() =>
                                    this.props.removeQuestion(
                                        this.state.questionIdToRemove,
                                        profileQuestions.list
                                    )}
                            >
                                Remove
                            </Button>
                        </div>
                    </div>
                </Modal>
                <ConfigurationKeySetModal
                    modalId={`modal-configuration-key-${this.key}`}
                    data={this.state.config}
                    handleSubmit={handleSubmit}
                    onUpdateConfigKey={this.props.onUpdateConfigKey}
                    onResetConfigKey={this.props.onResetConfigKey}
                    modal={this.props.modal}
                    reset={this.props.reset}
                    change={this.props.change}
                    initialize={this.props.initialize}
                    isConfigUpdating={this.props.isConfigUpdating}
                />
            </Section>
        )
    }
}

export default enhance(ProfileQuestions)
